"use client";

import { Toaster } from "react-hot-toast";

/**
 * Themed react-hot-toast container (same toast library as the Hub).
 */
export function AppToaster() {
  return (
    <Toaster
      position="bottom-center"
      gutter={10}
      toastOptions={{
        duration: 4500,
        className:
          "!bg-popover !text-popover-foreground !border !border-border !rounded-xl !text-sm !shadow-2xl !px-4 !py-3",
        success: { iconTheme: { primary: "#22c55e", secondary: "#fff" } },
        error: { iconTheme: { primary: "var(--brand)", secondary: "#fff" } },
      }}
    />
  );
}
